export enum BaseballEventDetailId {
  WeatherConditions = 8,
  PitchConditions = 36,
  Attendance = 141,
  MercyRule = 206,
  Half = 59,
  ExtraInningsNumber = 207,
  FirstInningStartDate = 22,
  SecondInningStartDate = 23,
  ThirdInningStartDate = 24,
  FourthInningStartDate = 25,
  FifthInningStartDate = 26,
  SixthInningStartDate = 27,
  SeventhInningStartDate = 28,
  EighthInningStartDate = 29,
  NinthInningStartDate = 30,
  TenthInningStartDate = 208,
  EleventhInningStartDate = 209,
  TwelfthInningStartDate = 210,
  ThirteenthInningStartDate = 211,
  FourteenthInningStartDate = 212,
  FifteenthInningStartDate = 213,
  SixteenthInningStartDate = 214,
  SeventeenthInningStartDate = 215,
  EighteenthInningStartDate = 216,
  NineteenthInningStartDate = 217,
  TwentiethInningStartDate = 218,
  TwentyFirstInningStartDate = 219,
  TwentySecondInningStartDate = 220,
  TwentyThirdInningStartDate = 221,
}

export type BaseballEventDetailIdHalfValues = 'top' | 'bottom'
